<script>
import MapTile from './MapTile.svelte';
import { beforeUpdate, afterUpdate, onMount } from 'svelte';
import { createEventDispatcher } from 'svelte';

export let x;
export let y;
export let z;
export let width;
export let height;

const dispatch = createEventDispatcher();

let map;
let tiles = [];
let localZ;

function buildId(column, row, z) {
    return `${column}-${row}-${z}`
}

function exists(column, row, z) {
    const id = buildId(column, row, z);
    return tiles.filter(t => t.id === id).length > 0;
}

function populateMapStartingFrom(column, row) {
    addTile(column, row, z);
    addTile(column, row-1, z);
    addTile(column, row+1, z);
    addTile(column-1, row, z);
    addTile(column-1, row-1, z);
    addTile(column-1, row+1, z);
    addTile(column+1, row, z);
    addTile(column+1, row-1, z);
    addTile(column+1, row+1, z);
    addTile(column-2, row, z);
    addTile(column-2, row-1, z);
    addTile(column-2, row+1, z);
    addTile(column+2, row, z);
    addTile(column+2, row-1, z);
    addTile(column+2, row+1, z);
}

function addTile(column, row, zoom=NaN) {
    if (exists(column, row, zoom ? zoom : z)) {
        return;
    }
    tiles.push({id: buildId(column, row, zoom ? zoom : z), column: column, row: row, z: zoom ? zoom : z});
    dispatch("updatetiles", {tiles: tiles});
}

afterUpdate(() => {
    if (localZ != z) {
        tiles = [];
        localZ = z;
    }
    populateMapStartingFrom(Math.floor(x/width*-1)+2, Math.floor(y/height*-1)+1);
});

onMount(() => {
    localZ = z;
    addTile(76, 90, 8); //init
});
</script>

<style>
#map {
    width: 880px;
    height: 424px;
    overflow: hidden;
    position: relative;
    background-color: #e0e0e0;
}
@media only screen and (max-device-width : 1024px) {
  #map {
    width: 100%;
    height: 424px;
  }
}
</style>

<div id="map" bind:this={map}>
    <div style="transform: translate3d({x}px, {y}px, 0px) scale(1);">
        {#each tiles as tile (tile.id)}
            <MapTile isCenter={tile.isCenter} column={tile.column} row={tile.row} z={tile.z} width={width} height={height} />
        {/each}
    </div>
</div>
